export class Serializable {
    fromJSON(json: any) {
        for (let propName in json)
            this[propName] = json[propName];
        return this;
    }

}